import { ReactElement } from "react"

import {
    FirstLoginDispatcherKeys,
    SELECT_ORG_TYPE,
    ORG_DETAILS_FORM_INSTALLER,
    ORG_DETAILS_FORM_MANU,
    EXISTING_DEVICES_CHECK,
    HAS_EXISTING_DEVICES,
    SOFTWARE_PROVIDER_SETUP,
    EXPECTING_INVITE,
    MFA,
    ORG_SET_UP_SUCCESS,
    INVITE_REVIEW,
    INVITE_ARE_YOU_SURE,
    INVITE_ACCEPTED_SUCCESS,
} from "./firstLoginConstants"
import SoftwareProviderSetUp from "../installerScreens/softwareProviderSetUp"
import InviteAcceptedSuccess from "../inviteScreens/inviteAcceptedSuccess"
import InviteAreYouSure from "../inviteScreens/inviteAreYouSure"
import InviteReview from "../inviteScreens/inviteReview"
import ExistingDevicesCheck from "../manufacturerScreens/existingDevicesCheck"
import HasExistingDevices from "../manufacturerScreens/hasExistingDevices"
import MfaSetUp from "../mfa/mfaSetUp"
import ExpectingInvite from "../sharedScreens/expectingInvite"
import OrgDetailsForm from "../sharedScreens/orgDetailsForm"
import OrgSetUpSuccess from "../sharedScreens/orgSetUpSuccess"
import SelectOrgType from "../sharedScreens/selectOrgType"

export const FIRST_LOGIN_DISPATCHER: Record<
    FirstLoginDispatcherKeys,
    ReactElement
> = {
    [SELECT_ORG_TYPE]: <SelectOrgType />,
    [ORG_DETAILS_FORM_INSTALLER]: <OrgDetailsForm manu={false} />,
    [ORG_DETAILS_FORM_MANU]: <OrgDetailsForm manu />,
    [EXISTING_DEVICES_CHECK]: <ExistingDevicesCheck />,
    [HAS_EXISTING_DEVICES]: <HasExistingDevices />,
    [SOFTWARE_PROVIDER_SETUP]: <SoftwareProviderSetUp />,
    [EXPECTING_INVITE]: <ExpectingInvite />,
    [MFA]: <MfaSetUp />,
    [ORG_SET_UP_SUCCESS]: <OrgSetUpSuccess />,
    [INVITE_REVIEW]: <InviteReview />,
    [INVITE_ARE_YOU_SURE]: <InviteAreYouSure />,
    [INVITE_ACCEPTED_SUCCESS]: <InviteAcceptedSuccess />,
}
